import Cookies from 'js-cookie';

const defaultOptions = {
  path: '/',
  domain: '.americanexpress.com',
};

export function setCookie(name, value, options) {
  const cookieOpts = Object.assign(defaultOptions, options);
  Cookies.set(name, value, cookieOpts);
}

export function getCookie(name) {
  return Cookies.get(name);
}

export function removeCookie(name, options) {
  const cookieOpts = Object.assign(defaultOptions, options);
  Cookies.remove(name, cookieOpts);
}

export default function updateLocaleCookie(locale) {
  const localeCookie = getCookie('axplocale');
  if (localeCookie !== locale) {
    setCookie('axplocale', locale, {});
  }
}
